import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar({ darkMode, toggleMode }) {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(false);

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  useEffect(() => {
    const handleBodyClick = (event) => {
      if (openMenu && !event.target.closest('.navbar')) {
        setOpenMenu(false);
      }
    };

    const handleScroll = () => {
      if (openMenu) {
        setOpenMenu(false);
      }
    };

    document.body.addEventListener('click', handleBodyClick);
    window.addEventListener('scroll', handleScroll);

    return () => {
      document.body.removeEventListener('click', handleBodyClick);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [openMenu]);

  const handleLinkClick = () => {
    setOpenMenu(false);
  };

  return (
    <>
      <nav className="container-fluid navbar" id='Navbar'>
        <div className="Logo" data-aos="fade-down">
          <Link to="/" className="nav-link noman font-extrabold text-4xl" target='_self'>
            Noman.
          </Link>
        </div>
        <div className="nav-buttons-container inline-flex"> {/* New container */}
          <div className={`Nav-div ${openMenu ? 'active' : ''}`}>
            <ul className="nav-ul" data-aos="fade-down">
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                  to="/"
                  onClick={handleLinkClick}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
                  to="/about"
                  onClick={handleLinkClick}
                >
                  About
                </Link>
              </li>
              {/* Add similar logic for other links */}
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === '/services' ? 'active' : ''}`}
                  to="/services"
                  onClick={handleLinkClick}
                >
                  Servies
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === '/projects' ? 'active' : ''}`}
                  to="/projects"
                  onClick={handleLinkClick}
                >
                  Projects
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
                  to="/contact"
                  onClick={handleLinkClick}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div className="nav-buttons-container inline-flex"> {/* New container */}
            <div className={`darkMode p-2 text-2xl mt-1 me-2 ${darkMode ? 'sunMode' : 'moonMode'}`} onClick={toggleMode}>
              <i className={darkMode ? 'bx bx-sun' : 'bx bxs-moon'} ></i>
              {/* <i className='bx bxs-sun'></i> */}
            </div>
            <div className={`hamburger ${openMenu ? 'is-active' : ''}`} onClick={toggleMenu}>
              <div className="hamburger__container">
                <div className="hamburger__inner"></div>
                <div className="hamburger__hidden"></div>
              </div>
            </div>
          </div> {/* End of nav-buttons-container */}
        </div> {/* End of nav-buttons-container */}
      </nav>
      <a name='Home'></a>
    </>
  )
}

export default Navbar;